import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { SCSelect } from 'rollup-allspark';
import { HOUR_LIST } from '../../../config/constants/analytics-v2';
import { isEmpty } from '../../../utils';

const TimeSelector = ({ onTimeSelected, timeRange }) => {
  const [startTime, setStartTime] = useState(timeRange?.startTime);
  const [endTime, setEndTime] = useState(timeRange?.endTime);
  const [endTimeList, setEndTimeList] = useState(HOUR_LIST);

  useEffect(() => {
    setStartTime(timeRange?.startTime);
    setEndTime(timeRange?.endTime);
  }, [timeRange]);

  const onStartTimeSelect = value => {
    setStartTime(value);
    setEndTime(null);

    const endHours = HOUR_LIST.filter(hour => hour.id > value.id);

    if (value.id !== 0) {
      endHours.push(HOUR_LIST.find(hour => hour.id === 0));
    }

    setEndTimeList(endHours);
  };

  const onEndTimeSelect = value => {
    setEndTime(value);
    onTimeSelected({ startTime, endTime: value });
  };

  return (
    <div className="flex flex-col rounded-lg gap-y-4 border border-grey absolute w-full top-[64px] p-4 bg-white z-50">
      <SCSelect
        searchable
        options={HOUR_LIST}
        trackBy="id"
        label="title"
        searchAbleAttribute={['title', 'id']}
        title="Start Time"
        placeholder="Select Time"
        value={startTime}
        onSelect={onStartTimeSelect}
      />
      <SCSelect
        searchable
        options={endTimeList}
        trackBy="id"
        label="title"
        searchAbleAttribute={['title', 'id']}
        title="End Time"
        placeholder="Select Time"
        value={endTime}
        disabled={isEmpty(startTime)}
        onSelect={onEndTimeSelect}
      />
    </div>
  );
};

TimeSelector.propTypes = {
  onTimeSelected: PropTypes.func,
  timeRange: PropTypes.object,
};

export default TimeSelector;
